<template>
	<el-menu :default-active="this.path" router style="width: 200px; height:100%; min-height: calc(100vh - 40px)"
		unique-opened>
		<div style="display: flex;align-items: center;justify-content: center;padding: 11px 0;">
			<img alt="" src="@/assets/logo.png" style="width: 60px;">
		</div>
		<el-menu-item index="/home">
			<el-icon>
				<house />
			</el-icon>
			<span>首页</span>
		</el-menu-item>
		<el-sub-menu index="2">
			<template #title>
				<el-icon>
					<user />
				</el-icon>
				<span>方案管理</span>
			</template>
			<el-menu-item index="/allocation">方案生成</el-menu-item>
		</el-sub-menu>
		<el-sub-menu index="3">
			<template #title>
				<el-icon>
					<coin />
				</el-icon>
				<span>行程管理</span>
			</template>
			<el-menu-item index="/competition">行程列表</el-menu-item>
		</el-sub-menu>
		<el-sub-menu index="4">
			<template #title>
				<el-icon>
					<message />
				</el-icon>
				<span>酒店管理</span>
			</template>
			<el-menu-item index="/signup">酒店列表</el-menu-item>
		</el-sub-menu>
		<el-sub-menu index="5">
			<template #title>
				<el-icon>
					<goods />
				</el-icon>
				<span>景点管理</span>
			</template>
			<el-menu-item index="/publicize">景点列表</el-menu-item>

		</el-sub-menu>
		<el-sub-menu index="6">
			<template #title>
				<el-icon>
					<pie-chart />
				</el-icon>
				<span>车型管理</span>
			</template>
			<el-menu-item index="/goods">车型列表</el-menu-item>
		</el-sub-menu>
		<el-sub-menu index="8">
			<template #title>
				<el-icon>
					<trophy />
				</el-icon>
				<span>用餐管理</span>
			</template>
			<el-menu-item index="/pointlist">用餐列表</el-menu-item>
		</el-sub-menu>

	</el-menu>
</template>

<script>
	import request from "@/utils/request";
	import {
		ElMessage
	} from "element-plus";

	export default {
		name: "Aside",
		data() {
			return {
				user: {},
				identity: '',
				path: this.$route.path
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				request.get("/main/loadIdentity").then((res) => {
					if (res.code !== "0") {
						ElMessage({
							message: '用户会话过期',
							type: 'error',
						});
						sessionStorage.clear()
						request.get("/main/signOut");

					}
					window.sessionStorage.setItem("identity", JSON.stringify(res.data));
					this.identity = res.data
				});
				request.get("/main/loadUserInfo").then((result) => {
					if (result.code !== "0") {
						ElMessage({
							message: '用户会话过期',
							type: 'error',
						});
						request.get("/main/signOut");
						sessionStorage.clear()
						this.$router.replace({
							path: "/login"
						});
					}
					window.sessionStorage.setItem("user", JSON.stringify(result.data));
					this.user = result.data
				});
			},
		},
	}
</script>

<style scoped>
	.icon {
		margin-right: 6px;
	}

	.el-sub-menu .el-menu-item {
		height: 50px;
		line-height: 50px;
		padding: 0 45px;
		min-width: 199px;
	}
</style>